export const mapboxToken =
  'pk.eyJ1Ijoid2FudDJyaWRlIiwiYSI6ImNqZjRmcWF5dTEzYmkyem80cHlqdm12NHoifQ.0xfzlUl0SF6q44jyaSPeIg';
